import {Validators} from '@angular/forms';

import {OperatorFilterModel, OperatorModel} from '@spa/api';

import {NameValidator, WhitespaceValidator} from '@spa/validators';

import {ComponentTypesEnum} from 'appShared/enums';
import {FilterControlInterface} from 'appShared/interfaces';
import {AutocompleteControl, BaseControl, SelectControl} from 'appShared/classes';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface,
} from 'appShared/components';

export const PanelSettingsOperatorsIdSelector = 'editable';
export const PanelSettingsOperatorsFirstNameSelector = 'firstName';
export const PanelSettingsOperatorsMiddleNameSelector = 'middleName';
export const PanelSettingsOperatorsLastNameSelector = 'lastName';
export const PanelSettingsOperatorsEmailSelector = 'email';
export const PanelSettingsOperatorsRolesSelector = 'role';
export const PanelSettingsOperatorsStatusSelector = 'status';
export const PanelSettingsOperatorsStorageId = 'PanelSettingsOperatorsComponent';
export const PanelSettingsOperatorsNameMinLength = 3;

export const PanelSettingsOperatorsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: OperatorFilterModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: OperatorFilterModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 1
        }, {
            name: OperatorFilterModel.getEmailSelector(),
            placeholder: 'Email',
            controls: [
                new BaseControl({
                    name: OperatorFilterModel.getEmailSelector(),
                    value: null,
                    placeholder: 'Email',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2
        }, {
            name: OperatorFilterModel.getRoleIdSelector(),
            placeholder: 'Role',
            controls: [
                new AutocompleteControl({
                    name: OperatorFilterModel.getRoleIdSelector(),
                    value: null,
                    placeholder: 'Role',
                    validators: [],
                    options: [],
                    componentType: ComponentTypesEnum.Autocomplete
                })
            ],
            sortIndex: 3
        }
    ];
};

export const PanelSettingsOperatorsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: OperatorModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OperatorModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OperatorModel.getUserRolesSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelSettingsOperatorsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Name',
                selector: OperatorModel.getNameSelector()
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: OperatorModel.getEmailSelector()
            }),
            new ReportTableColumn({
                label: 'Roles',
                selector: OperatorModel.getUserRolesSelector()
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export interface PanelSettingsOperatorsControlsInterface {
    firstName: BaseControl;
    middleName: BaseControl;
    lastName: BaseControl;
    status: SelectControl;
    email: BaseControl;
    role: SelectControl;
}

export const PanelSettingsOperatorsFormControls = (): PanelSettingsOperatorsControlsInterface => {
    return {
        firstName: new BaseControl({
            name: PanelSettingsOperatorsFirstNameSelector,
            value: '',
            placeholder: 'First Name',
            validators: [
                WhitespaceValidator(),
                NameValidator(),
                Validators.minLength(PanelSettingsOperatorsNameMinLength)
            ],
            componentType: ComponentTypesEnum.Text,
        }),
        middleName: new BaseControl({
            name: PanelSettingsOperatorsMiddleNameSelector,
            value: '',
            placeholder: 'Middle Name',
            validators: [NameValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        lastName: new BaseControl({
            name: PanelSettingsOperatorsLastNameSelector,
            value: '',
            placeholder: 'Last Name',
            validators: [
                WhitespaceValidator(),
                NameValidator(),
                Validators.minLength(PanelSettingsOperatorsNameMinLength)
            ],
            componentType: ComponentTypesEnum.Text,
        }),
        status: new SelectControl({
            name: PanelSettingsOperatorsStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        email: new BaseControl({
            name: PanelSettingsOperatorsEmailSelector,
            value: '',
            placeholder: 'Email',
            validators: [WhitespaceValidator(), Validators.email],
            componentType: ComponentTypesEnum.Text
        }),
        role: new SelectControl({
            name: PanelSettingsOperatorsRolesSelector,
            value: null,
            placeholder: 'Roles',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: true
        })
    };
};
